module.exports = __webpack_public_path__ + "img/big-logo.1a44e18c.png";